
import barba from '@barba/core';

export default class{

    constructor(){
        barba.hooks.afterOnce((data) => {
            this.init()
        })
        barba.hooks.after((data) => {
            this.init()
        });
    }
    init (){
      
        this.heroContent = document.querySelector("#l-hero__wrapper")
        this.heroContentWrapper = document.querySelector("#l-hero__wrapper #l-hero__image")
        if(this.heroContent){
            let winH = window.innerHeight
            let timeoutId
            let is_scroll = false
            this.heroContent.style.height = winH + "px"
            this.heroContentWrapper.style.height = winH + "px"
            window.addEventListener("resize", () => {
                if( is_scroll ){
                    return false
                }
                let winH = window.innerHeight
                this.heroContent.style.height = winH + "px"
                this.heroContentWrapper.style.height = winH + "px"
                
            })
            window.addEventListener("scroll", () => {
                is_scroll = true
                clearTimeout( timeoutId ) ;
                timeoutId = setTimeout(() => {
                    if( is_scroll ){
                        is_scroll = false
                    }
                }, 1000 ) ;
            })
            
            window.addEventListener("touchmove", () => {
                if( !is_scroll ){
                    is_scroll = true
                }
            })
            window.addEventListener("touchend", () => {

                clearTimeout( timeoutId ) ;
                timeoutId = setTimeout(() => {
                    if( is_scroll ){
                        is_scroll = false
                    }
                }, 1000 ) ;
                
            })
        }
    }
}